import React from "react";
import {
  Grid,
  Box,
  Typography,
  Link,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Logo from "../../assets/images/StyLogo.png";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import API from "../../utils/Axios.utils";
import { useNavigate, useParams } from "react-router-dom";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Notification } from "../../utils/Notification";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const ResetPassword = () => {
  const navigate = useNavigate();
  const { key } = useParams();
  const [showPassword, setShowPassword] = React.useState(false);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const handleAlert = () => {
    setAlert(false);
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const resetPassSchema = Yup.object().shape({
    password: Yup.string()
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
        "Your password must be at least 8 characters long,first letter must be uppercase, contain at least one number and have a mixture of uppercase and lowercase letters."
      )
      .required("Password is required."),
    confirmpassword: Yup.string()
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$/,
        "Your password must be at least 8 characters long,first letter must be uppercase, contain at least one number and have a mixture of uppercase and lowercase letters."
      )
      .required("Password is required.")
      .oneOf([Yup.ref("password")], "Both password need to be the same"),
  });

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmpassword: "",
    },
    validationSchema: resetPassSchema,
    onSubmit: async () => {
      await handleRequest(formik);
    },
  });

  const handleRequest = async (formik) => {
    try {
      const dataa = {
        newPassword: formik.values.password,
        resetToken: key,
      };

      const res = await API.post("/api/users/reset_password", dataa);
      console.log(res?.data?.message);
      setAlertContent(res?.data?.message);
      setAlertType("success");
      setAlert(true);
      navigate("/login");
    } catch (error) {
      setAlertContent(error.response.data.message);
      setAlertType("error");
      setAlert(true);
    }
  };

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } =
    formik;

  return (
    <div className="global_bg">
      <Grid
        container
        className="global_text"
        justifyContent="space-between"
        align="center"
        p="10%"
        gap="20px"
        direction="column"
      >
        <Grid item>
          <img src={Logo} width={300} height={80} alt="logo" />
          <Typography>
            <h2>Reset password</h2>
          </Typography>
          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
              style={{ maxWidth: "400px" }}
            >
              <TextField
                fullWidth
                size="small"
                name="password"
                autoComplete="current-password"
                type={showPassword ? "text" : "password"}
                placeholder="New password"
                {...getFieldProps("password")}
                error={Boolean(touched.password && errors.password)}
                helperText={touched.password && errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={handleClickShowPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Box sx={{ mt: 2, mb: 3 }}>
                <TextField
                  fullWidth
                  name="confirmpassword"
                  size="small"
                  type={showPassword ? "text" : "password"}
                  placeholder="Confirm password"
                  {...getFieldProps("confirmpassword")}
                  error={Boolean(
                    touched.confirmpassword && errors.confirmpassword
                  )}
                  helperText={touched.confirmpassword && errors.confirmpassword}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Button variant="contained" type="submit">
                RESET
              </Button>
              <Link
                className="login-text-color"
                variant="subtitle2"
                sx={{ cursor: "pointer" }}
                onClick={() => navigate("/", { replace: true })}
              >
                <Grid>
                  <Button variant="text">
                    <NavigateBeforeIcon /> Back to Login
                  </Button>
                </Grid>
              </Link>
              <Notification
                message={alertContent}
                open={alert}
                severity={alertType}
                onClose={handleAlert}
              />
            </Form>
          </FormikProvider>
        </Grid>
      </Grid>
    </div>
  );
};

export default ResetPassword;
